import { LegalPerson } from './legal-person'

export type RegistrationType = 'preregistered'
export type SituationType = 'pending' | 'received'
export type SituationStatus =
  | 'rejected'
  | 'onboarding'
  | 'verified'
  | 'onboarded'
  | 'waiting_whatsapp'
  | 'sent_documents'
  | 'user_not_registered'
  | 'unauthorized'
  | 'waiting_docs'
  | 'waiting_provider'
  | 'waiting_analysis'

export interface Situation {
  background_check_status: SituationType
  document_back_photo_status: SituationType
  document_front_photo_status: SituationType
  face_match_status: SituationType
  has_pending_terms_to_sign: boolean
  has_email_validation: boolean
  ocr_status: SituationType
  registration_type?: RegistrationType
  self_photo_status: SituationType
  status: SituationStatus
  legal_person_situation: LegalPerson[]
  kyc_mode?: KYCMode
  has_facial_recognition?: boolean
}

export type KYCMode = 'quiz' | 'docs' | 'IDUnico' | 'choose_type'

export type UserSituationStatus =
  | 'waiting_analysis'
  | 'onboarded'
  | 'waiting_docs'
  | 'unknown'
  | 'unauthorized'

export enum UserSituationStatusEnum {
  Analysis = 'waiting_analysis',
  Onboarded = 'onboarded',
  Waiting = 'waiting_docs',
  Unknown = 'unknown',
  Unauthorized = 'unauthorized',
}
